import React from 'react';
import Radium from 'radium';
import Article from './article.js';

class Contact extends Article {
  // overwrite parent
  componentDidMount(){}

  render() {
    const { headline, fullText } = this.props.content;
    const style = this.getStyle();

    return (
      <div style={ style.article}>
        <h1
          ref="headline" 
          id={ this.props.headlineId }
          style={[style.reset, style.h1]}>
          { headline }
        </h1>
        <p
          style={[style.reset, style.text]}>
          { fullText }
        </p>
      </div>
    );
  }
}

export default Radium(Contact);


// WEBPACK FOOTER //
// ./src/modules/impress.js